import React, { Fragment } from 'react'
import SetClient from './SetClient'
import { updateVM } from './update'

const acceptClientSuggestion = (vm, updateVMs) => {
  updateVM({
    vm,
    updateVMTableData: updateVMs,
    patchData: {
      client_data_source: 'Manual',
      viaje_client_id: vm.temporary_viaje_client_id,
      client_id_manually_set: true
    }
  })
}

const AcceptClientSuggestion = ({ vm, updateVMs, customerOptions }) => (
  <Fragment>
    <div className="row mb-3">
      <div className="col">
        <button className='btn btn-primary' onClick={() => acceptClientSuggestion(vm, updateVMs)}>
          Accept client suggestion
        </button>
      </div>
    </div>

    <div className="row">
      <div className="col">
        <SetClient {...{ vm, updateVMs, customerOptions }} />
      </div>
    </div>
  </Fragment>
)

export default AcceptClientSuggestion
